import { Theme } from "@material-ui/core/styles";

// ----------------------------------------------------------------------

export default function Pickers(theme: Theme) {
  return {};
}
